import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"6\" height=\"6\" x=\"4\" y=\"4.7\" stroke=\"#151515\" stroke-width=\"2\" rx=\"1\"></rect><rect width=\"6\" height=\"6\" x=\"4\" y=\"14.2\" stroke=\"#151515\" stroke-width=\"2\" rx=\"1\"></rect><path stroke=\"#151515\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M14 6h6\"></path><path stroke=\"#F56A00\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M14 15h6\"></path><path stroke=\"#151515\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M14 10h6m-6 9h6\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }